/**
 * Rich Matching content validator
 * Validates rich matching data for required fields
 */

import type { ContentValidator, ValidationResult } from '@ai-content-hub/content-core';
import type { RichMatchingData } from './schema';

export const richMatchingValidator: ContentValidator<RichMatchingData> = {
    validate(data: RichMatchingData): ValidationResult {
        const errors: ValidationResult['errors'] = [];

        if (!data?.title?.trim()) {
            errors.push({ field: 'title', message: 'Title is required.' });
        }

        const matchItems = data?.matchData?.items ?? [];
        const matchOptions = data?.matchData?.options ?? [];
        const optionIds = new Set(matchOptions.map((o) => o.id));

        // Check for at least 2 complete matching pairs (item linked to a valid option)
        const completePairs = matchItems.filter(
            (item) => item.correctOptionId && optionIds.has(item.correctOptionId),
        );

        if (completePairs.length < 2) {
            errors.push({
                field: 'matchData.items',
                message: 'Phải tạo ít nhất 02 cặp ghép nối (Vế A - Vế B) hoàn chỉnh.',
            });
        }

        return { isValid: errors.length === 0, errors };
    },
};
